import React, { FC } from 'react';
import cn from 'classnames';
import LazyImage from 'generic/LazyImage';
import { MobileSliderContainer } from './MobileSliderSlyles';

interface Props {
  photos: string[];
}

const MobileSlider: FC<Props> = ({ photos }) => {
  if (!photos) return null;

  const className = cn({ image: true, full: photos.length === 1 });
  const renderPhotos = () =>
    photos.map((src) => (
      <LazyImage key={`lazyImage-${src}`} src={src} className={className} rootMargin="50px" />
    ));

  return <MobileSliderContainer>{renderPhotos()}</MobileSliderContainer>;
};

export default MobileSlider;
